const refs = {
  menu: document.querySelector('[mobile-menu]'),
  openMenuBtn: document.querySelector('[mobile-menu-open]'),
  closeMenuBtn: document.querySelector('[mobile-menu-close]'),
  htmlAndBody: document.querySelectorAll('[no-scroll]'),
  html: document.querySelector('html'),
  decorStarsContainer: document.querySelector('[decor-stars-container]'),
  gallery: document.querySelector('[data-gallery]'),
};

export { refs };
